<template>
  <div>
    <div class="searchInput">
      <input
        type="text"
        :placeholder="locale.search_place_placeholder"
        ref="searchPlaceInput"
        v-model="searchInput"
        @keypress.enter="getPlace">
      <button
        type="button"
        class="btnSearch"
        @click.stop="getPlace">
        </button>
    </div>
    <div class="listData">
      <div
        v-if="placeList"
        class="placeList">
        <p class="mb5">{{locale.search_place_destination_select}}</p>
        <div
          v-for="(place, index) in placeList"
          :key="index"
          class="placeItem"
          @click.stop="selectItem(place)">
          <p class="name">{{ place.name }}</p>
          <p class="address">{{ place.address }}</p>
        </div>
      </div>
      <div v-else class="noData">{{locale.search_place_destination_input}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchPlace',
  props: [
    'locale'
  ],
  components: {
  },
  mounted () {
    this.$nextTick(() => {
      const input = this.$refs.searchPlaceInput
      if (input) {
        input.focus()
      }
    })
  },
  data () {
    return {
      searchInput: '',
      placeList: null,
      selected: null
    }
  },
  methods: {
    getPlace () {
      if (this.searchInput) {
        this.$store.dispatch('guest/getPlace', this.searchInput).then((res) => {
          if (res && res.places) {
            this.placeList = res.places.map(x => {
              return {
                placeId: x.id,
                name: x.displayName.text,
                address: x.shortFormattedAddress || x.formattedAddress,
                ...x.location && {
                  location: {
                    lat: x.location.latitude,
                    lng: x.location.longitude
                  }
                }
              }
            })
          }
        })
      } else {
        alert(this.locale.alert_empty_place_input)
      }

    },
    async selectItem (item) {
      const selectData = {
        name: item.name,
        address: item.address,
        location: item.location
      }
      this.$emit('select', selectData)
    }
  }
}
</script>

<style lang="scss" scoped>
.searchInput {
  display: flex;
  align-items: center;
  border-bottom: 1px solid $color-lgrey2;
  input {
    flex: 1;
    min-width: 0;
    padding: 4px 0;
    border: none;
  }
  .btnSearch {
    width: 20px;
    height: 20px;
    border: none;
    background: url('~@/assets/img/ico_search.svg') 50% 50% / contain no-repeat;
    opacity: 0.7;
  }
}
.listData {
  margin-top: 15px;
  overflow: hidden;
  .placeItem {
    margin-bottom: 4px;
    padding: 8px;
    border: 1px solid $color-lgrey2;
    border-radius: 8px;
    cursor: pointer;
    .address {
      font-size: 12px;
      color: $color-lgrey;
    }
  }
  .noData {
    padding-top: 60px;
    text-align: center;
    font-size: 20px;
    color: $color-lgrey;
  }
}
@media screen and (min-width: 768px) {
  .searchInput {
    input {
      font-size: 20px;
    }
    .btnSearch {
      width: 24px;
      height: 24px;
    }
  }
  .listData {
    margin-top: 30px;
    .placeItem {
      padding: 15px;
      .name {
        font-size: 18px;
      }
      .address {
        font-size: 14px;
      }
    }
    .noData {
      padding-top: 90px;
      font-size: 24px;
    }
  }
}
</style>
